import React from 'react'
import { Row, Col, Card } from 'antd';

function RefundPolicy() {
    return (
        <>

            <section className='informationBanner'>
                <div className='container'>
                    <Row gutter={16} align="middle">
                        <Col md={16} sm={24}>
                            <div className='Package-cntr'>
                                <h2>Refund Policies</h2>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            <section className='SiteInformation-area'>
                <div className='container'>
                    <Row gutter={16}>
                        <Col md={24}>
                            <Card className='my-5'>
                                <h1>Refund Policies for Superb World Trip</h1>

                                <h3 className='fw-bold mb-3'>
                                Flight Booking Terms
                                </h3>
                                <h4 className='fw-bold text-primary mb-2'>Modifications</h4>
                                <ol>
                                    <li>Every modification in the booking made on the Superb World Trip site is subject to modification charges levied by the Airline, which may vary by flight, date and class of booking.</li>
                                    <li>In case of rescheduling, the current booking ID will be auto-cancelled and a fresh booking ID will be generated based on current pricing.</li>
                                    <li><b>For the Rescheduling of flights, a charge fee of Rs. 300 per passenger per sector will be charged to us in addition to the Airline’s Rescheduling charges.</b></li>
                                    <li>Flight booking made through the SuperbWorldTrip website can also be modified by calling the Airline directly.</li>
                                    <li>In addition to the above the Users agree to the terms & conditions of Airlines/Suppliers/superbworldtrip.</li>
                                </ol>

                                <h4 className='fw-bold text-primary mb-2'>Cancellation Policy:</h4>
                                <ol>
                                    <li>Every cancellation of booking made on SuperbWorldTrip is subject to cancellation charges levied by the Airline, which may vary by flight, date and class of booking.</li>
                                    <li>Some booked flight tickets are non-refundable as per the airline’s policies.</li>
                                    <li>We accept both online and offline flight ticket cancellation requests.</li>
                                    <li className='text-danger'>We charge an additional Rs. 600 per passenger per sector, in addition to the Airline’s cancellation charges.</li>
                                    <li>Only the cancellation request made through telephone or email will be entertained.</li>
                                    <li>In the case of e-tickets, if you are initiating a cancellation request within 24 hours from the departure, then you are recommended to contact the Airline directly to avoid the inconvenience</li>
                                </ol>
                                
                                <h4 className='fw-bold text-primary mb-2'>Refunds:</h4>
                                <ol>
                                    <li>The passengers are required to contact SuperbWorldTrip Company directly for the refunds, the Airline will not be able to process refunds for the tickets booked at SuperbWorldTrip.</li>
                                    <li>The time taken for processing the request for refund and cancellation may vary and can take up to 5 to 7 working days</li>
                                    <li>Refunds for partially utilized tickets will be processed as per the Airline’s prevalent guidelines Refunds for partially used tickets can take up to 25 to 30 working days, depending upon the booking class and fare charged by Airline and Airline/Supplier policy.</li>
                                    <li>No refund will be provided for “no-shows"</li>
                                    <li>No refund will be provided for “Surcharge and Convenience fees”.</li>
                                </ol>
                                <p className='fw-bold mb-3'>In addition to the above-mentioned terms and conditions, please check the terms and conditions of your respective Airline as well. Those terms and conditions also apply to you.</p>

<hr />

                                <h3 className='fw-bold mb-3'>Hotel Booking Terms</h3>
                                <h4 className='fw-bold text-primary mb-2'>Cancellation Policy</h4>
                                <ol>
                                    <li>Cancellation of Hotel bookings can be done online as well as by contacting superbworldtrip call centres.</li>
                                    <li>Only the cancellation requests made online or via Mobile phones will be entertained. superbworldtrip will not be responsible for any cancellation made directly with the Hotel or done via any other medium, including but not limited to SMS.</li>
                                    <li>Even if you don’t check in at the Hotel, the Hotel will still charge you for the Room Booked and deduct the full cancellation amount that you have paid.</li>
                                    <li>The terms & conditions of the hotel's policy will be applicable.</li>
                                </ol>
                                
                                <h4 className='fw-bold text-primary mb-2'>Refund Policy</h4>
                                <ol>
                                    <li>A refund will be initiated by superbworldtrip within 48 hours of receiving the request.</li>
                                    <li>A refund will be processed as per the hotel's policy, and apart from that, we will charge a cancellation fee of Rs.300.</li>
                                    <li>The refund request can take up to 5 to 7 working days to process and to credit the amount in the Bank account.</li>
                                </ol>
                               
                                <h4 className='fw-bold text-primary mb-2'>Covid - 19</h4>
                               <p>Users agree that they will follow the protocol and standard operating procedures prescribed by the Central/State governments/statutory bodies that a traveller has to observe to undertake the travel. Failure to abide by such protocol / standard operating procedures may disallow the User to undertake the travel. In such circumstances, superbworldtrip will not be held liable for such refusal to travel and refund, if any. This will be treated as a “no show” and there will be no refund.
                               </p>

                            </Card>
                        </Col>
                    </Row>
                </div>
            </section>

        </>
    )
}

export default RefundPolicy